import React from 'react';
import strings from '../../lang/strings.js';
import $ from 'jquery';
import { PageSettings } from "../../config/page-settings";
import './../../config/util';
import DataTable from './../../components/content/data-table.jsx';
import MemberDetailPopup from './../member-detail/member-detail-popup'

class BoardDetailCard extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.state = {
            show_member_profile: false,
            selected_uid: 0
        }

    }

    componentDidMount() {
    }

    showMemberDetailPopup(uid) {
        this.setState({
            show_member_profile: true,
            selected_uid: uid
        });
    }

    render() {
        let self = this;
        let columnNo = 0;

        return (
            <div>
                <MemberDetailPopup isOpen={this.state.show_member_profile} uid={this.state.selected_uid} onClose={() => {
                    this.setState({ show_member_profile: false });
                }} />
                <div className='row'>
                    <div className='col-md-12 mt-3'>
                        <DataTable ref={(ref) => this.tblMember = ref}
                            options={{
                                columnDefs: [
                                    {
                                        targets: [columnNo++], data: 'id', orderable: false,
                                        render: function (value) {
                                            return value;
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'nickname', orderable: false,
                                        createdCell: function (td, value, item) {
                                            return $(td).nickname_label(value, item.gender, () => {
                                                self.showMemberDetailPopup(item.uid);
                                            });
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'target_nickname', orderable: false,
                                        createdCell: function (td, value, item) {
                                            return $(td).nickname_label(value, item.target_gender, () => {
                                                self.showMemberDetailPopup(item.target_uid);
                                            });
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'create_date', orderable: false,
                                        render: function (value) {
                                            return value
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'target_ok', orderable: false,
                                        render: function (value) {
                                            return value > 0 ? `<span style="color: red">${strings.match_success}</span>` : `<span style="color: blue">${strings.ok_sent}</span>`
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'reply_date', orderable: false,
                                        render: function (value) {
                                            return value
                                        }
                                    },
                                    {
                                        targets: [columnNo++], data: 'status', orderable: false,
                                        render: function (value) {
                                            return value == -1 ? `<span style="color: red">${strings.deleted}</span>` : '';
                                        }
                                    },
                                ],
                                order: [[1, 'DESC']],
                                ajax: {
                                    url: 'board/getCardList',
                                    data: function (req) {
                                        req.columns = null;
                                        req.board_id = self.props.board_id;
                                    }
                                },
                                drawCallback: function () {
                                },
                                fnCreatedRow: function (row, data, dataInd) {
                                }
                            }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{strings.user}-1</th>
                                    <th>{strings.user}-2</th>
                                    <th>{strings.ok_date}</th>
                                    <th>{strings.match_result}</th>
                                    <th>{strings.match_date}</th>
                                    <th>{strings.status}</th>
                                </tr>
                            </thead>
                            <tbody />
                        </DataTable>
                    </div>
                </div>
            </div>
        )
    }
}

export default BoardDetailCard;